//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const artifact = [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    4, 4, 5, 0, 0, 1, 1, 0, 0, 5, 4, 4, 
    4, 4, 0, 0, 1, 0, 0, 1, 0, 0, 4, 4, 
    5, 0, 1, 1, 0, 2, 2, 0, 1, 1, 0, 5, 
    3, 0, 0, 0, 2, 2, 2, 2, 0, 0, 0, 3, 
    0, 3, 2, 2, 2, 1, 1, 2, 2, 2, 3, 0, 
    3, 0, 2, 2, 2, 1, 1, 2, 2, 2, 0, 3, 
    0, 3, 0, 0, 2, 2, 2, 2, 0, 0, 3, 0, 
    0, 0, 0, 1, 0, 2, 2, 0, 1, 0, 0, 0, 
    0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 4, 4, 0, 0, 0, 0, 0, 
    0, 0, 0, 0, 5, 4, 4, 5, 0, 0, 0, 0,
]